import loaderGif from '@assets/logo_animation.gif';
import styles from './AppLoader.module.css';

type AppLoaderProps = {
  size?: 'small' | 'default' | 'large';
  minHeight?: number | string;
  inline?: boolean;
  className?: string;
};

const buildClassName = (...names: Array<string | false | null | undefined>) =>
  names.filter(Boolean).join(' ');

export const AppLoader = ({
  size = 'default',
  minHeight,
  inline = false,
  className,
}: AppLoaderProps) => {
  const sizeClassName =
    size === 'small' ? styles.small : size === 'large' ? styles.large : styles.default;

  if (inline) {
    return (
      <span className={buildClassName(styles.inline, className)} aria-hidden="true">
        <img
          src={loaderGif}
          alt=""
          className={buildClassName(styles.loaderImage, sizeClassName)}
          draggable={false}
        />
      </span>
    );
  }

  return (
    <div
      className={buildClassName(styles.block, className)}
      style={minHeight !== undefined ? { minHeight } : undefined}
      aria-hidden="true"
    >
      <img
        src={loaderGif}
        alt=""
        className={buildClassName(styles.loaderImage, sizeClassName)}
        draggable={false}
      />
    </div>
  );
};
